import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { defer } from 'lodash';
import AllCities from '../../components/AllCities';
import { setSelectedLocationThunk } from '../../../../../ui-kitchen/src/reducers/resyLocationsSlice';
import { setLocationPath } from '../../../../../ui-kitchen/src/utils/locationUtils';

const AllCitiesContainer = ({
  $rootScope, $window, dispatch, locations, ...passThroughProps
}) => {
  const handleLocationSelect = (location) => {
    const params = {
      location,
      $rootScope,
      $window,
    };
    const { search } = window.location;
    dispatch(setSelectedLocationThunk(params));
    setLocationPath(`/cities/${location.url_slug}${search}`, () => defer(() => $rootScope.$apply()));
  };

  if (!locations.length) return null;

  return (
    <AllCities
      {...passThroughProps}
      locations={locations}
      onLocationSelect={handleLocationSelect}
    />
  );
};

AllCitiesContainer.displayName = 'AllCitiesContainer';

AllCitiesContainer.propTypes = {
  $rootScope: PropTypes.shape({
    $apply: PropTypes.func.isRequired,
  }).isRequired,
  $window: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = ({ resyLocations }) => ({
  locations: resyLocations.nav,
});

export { AllCitiesContainer as ComponentUnderTest };
export default connect(mapStateToProps)(AllCitiesContainer);
